const removeTTWaterMark = {
  HitPawTikTokTitle: 'HitPaw Online TikTok Watermark Remover',
  ExportVideoWithoutWaterMark: "Exportar vídeo sem marca d'água HitPaw",
  ProcessTiktokLinkWithoutLimits: 'Processe os links do TikTok sem limites',
  FasterProcessingSpeed: 'Velocidade de processamento 10 vezes mais rápida',
  PrioritySupport: 'Suporte prioritário',
  DiscountPrice: 'R$4.99',
  WeekTotalPrice: 'R$21,99',

  MonthWeekPrice: 'R$8,99',
  MonthTotalPrice: 'R$81,99',

  YearWeekPrice: 'R$4,39',
  YearTotalPrice: 'R$219,99',
  Day: 'Dia',
  Monthly: 'Mensalmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  week: 'Semana',
};

export default removeTTWaterMark;
